import {ProductTypeGuidDto} from '../../../models/ProductTypes/IProductTypeGuid';

export const getRecipeProductTypeAssignments = (productTypes: ProductTypeGuidDto[]): Map<string, ProductTypeGuidDto> => {
    const assignments = new Map<string, ProductTypeGuidDto>();

    productTypes.forEach(productType => {
        productType.recipes.forEach(recipe => assignments.set(recipe.id, productType));
    });

    return assignments;
};
